export const Roles = {
    Admin: 'Admin',
    Student: 'Student'
  };